// extracted by mini-css-extract-plugin
export default {"table":"ProjectScorecards_table__MSsIU"};